<template>
    <div class="objectives-main">
             <div class="image-obj-main">
                 <img src="../../assets/computer.png" id="image-obj">
                 <div class="obj-title"> Interactive Learning </div>
            </div>
             <div class="image-obj-main">
                <img src="../../assets/correctwrong.png" id="image-obj">
                <div class="obj-title"> Fix bugs together! </div>
             </div>
             <div class="image-obj-main">
                <img src="../../assets/peoples.png" id="image-obj">
                <div class="obj-title"> Active Community Server </div>
             </div>
            <div class="image-obj-main">
                <img src="../../assets/robot.png" id="image-obj">
                <div class="obj-title"> Project-Based Learning </div>
            </div>
         </div>    
</template>
<script>
export default {
    name:'Objectives'
}
</script>

<style scoped>
 
    .objectives-main{
       
        display: grid;
        width: 100%;
       grid-template-columns: auto auto;
        justify-content: center;
        margin-bottom:1rem ;
    }
    .image-obj-main{
        /* border:1px solid rgb(185, 185, 185); */
        background-color: white;
        margin: 1rem;
        padding: 0.5rem;
        /* border: 1px solid rgb(116, 116, 116); */
        box-shadow: 0rem 0.1rem 0.1rem 0rem  #8f8e8e;
        border-radius: 0.5rem;
        
        
    }
    .obj-title{
        font-family: 'Chelsea Market', cursive;
        font-size: 1.2em;
        text-align: center;
    }

    #image-obj{
        width: 18rem;
        
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
    }
    @media screen and (max-width:768px){
        #image-obj{
        width: 16rem;
        }
        .objectives-main{
        
        display: grid;
        width: 100%;
       grid-template-columns: auto;
        justify-content: center;
        
    }
    }
</style>